import * as React from 'react';

import { StyledButtonRemove } from './styles';
import Utils from '../../../../utils';

interface ButtonRemoveProps {
	onClick: () => void;
	isDisabled?: boolean;
}

const ButtonRemove = ({ onClick, isDisabled }: ButtonRemoveProps) => (
	<StyledButtonRemove
		type="button"
		disabled={isDisabled}
		onClick={onClick}
	>
		{Utils.getSvgIcon('iconset_close-2')}
	</StyledButtonRemove>
);

export default ButtonRemove;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ButtonRemove/index.tsx